import { Particle } from "../particle";
import {
	colorConstant,
	deceleratingMotion,
	hold,
	lerp,
	randomAngle,
	randomBetween,
	randomSign,
} from "../interpolation";

export class PlasmaCloudParticle extends Particle {
	constructor(originX: number, originY: number) {
		const spawnAngle = randomAngle();
		const spawnRadius = Math.sqrt(Math.random()) * 0.7;
		const spawnX = originX + Math.cos(spawnAngle) * spawnRadius;
		const spawnY = originY + Math.sin(spawnAngle) * spawnRadius;

		const angle = randomAngle();
		const speed = randomBetween(1.0, 2.5);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		super(spawnX, spawnY, {
			ttl: randomBetween(500, 1100),
			size: lerp(randomBetween(0.5, 0.7), randomBetween(0.9, 1.1)),
			opacity: hold(0.5, 0.5, lerp(0.5, 0)),
			color: colorConstant(randomBetween(90, 150), randomBetween(180, 220), 255),
			rotation: lerp(0, randomSign() * randomBetween(1, 2)),
			position: deceleratingMotion(vx, vy, 2.5),
		});
	}
}
